import React from "react";
//#region types
import { AdaptiveDetailTableViewProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import AdaptiveDetailTableView from "./adaptiveDetailTableView";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

function AdaptiveDetailTableViewSmall<RowType extends Record<string, any>>(
  props: AdaptiveDetailTableViewProps<RowType>
) {
  return (
    <AdaptiveDetailTableView {...props} className={clsx(cssExports.adaptiveDetailTableViewSmall, props.className)} />
  );
}

export default AdaptiveDetailTableViewSmall;
